/* eslint-disable prefer-spread */
import { Injector } from '@angular/core';
import {
  EafMultiTenancyService,
  FeatureCheckerService,
  LocalizationService,
  MessageService,
  NotifyService,
  PermissionCheckerService,
  SettingService,
} from 'src/assets/lib/eaf-ng2-module';

import { AppConsts } from '../AppConsts';
import { AppUrlService } from '../common/nav/app-url.service';
import { AppSessionService } from '../common/session/app-session.service';
import { AppUiCustomizationService } from '../common/ui/app-ui-customization.service';
import { DataTableHelper } from '../helpers/DataTableHelper';
import { UiCustomizationSettingsDto } from '../service-proxies/service-proxies';

export abstract class AppComponentBase {
  localizationSourceName = AppConsts.localization.defaultLocalizationSourceName;
  localizationSourceNameEaf = AppConsts.localization.defaultLocalizationSourceNameEaf;

  localization: LocalizationService;
  permission: PermissionCheckerService;
  feature: FeatureCheckerService;
  notify: NotifyService;
  setting: SettingService;
  message: MessageService;
  multiTenancy: EafMultiTenancyService;
  appSession: AppSessionService;
  dataTableHelper: DataTableHelper;
  ui: AppUiCustomizationService;
  appUrlService: AppUrlService;

  constructor(injector: Injector) {
    this.localization = injector.get(LocalizationService);
    this.permission = injector.get(PermissionCheckerService);
    this.feature = injector.get(FeatureCheckerService);
    this.notify = injector.get(NotifyService);
    this.setting = injector.get(SettingService);
    this.message = injector.get(MessageService);
    this.multiTenancy = injector.get(EafMultiTenancyService);
    this.appSession = injector.get(AppSessionService);
    this.ui = injector.get(AppUiCustomizationService);
    this.appUrlService = injector.get(AppUrlService);
    this.dataTableHelper = new DataTableHelper();
  }

  l(key: string, ...args: any[]): string {
    args.unshift(key);
    args.unshift(this.localizationSourceName);
    return this.ls.apply(this, args);
  }

  ls(sourcename: string, key: string, ...args: any[]): string {
    let localizedText = this.localization.localize(key, this.localizationSourceName);

    if (!localizedText || localizedText == key) localizedText = this.localization.localize(key, this.localizationSourceNameEaf);

    args.unshift(localizedText);

    return eaf.utils.formatString.apply(this, args);
  }

  isGranted(permissionName: string): boolean {
    return this.permission.isGranted(permissionName);
  }

  isGrantedAny(...permissions: string[]): boolean {
    if (!permissions) {
      return false;
    }

    for (const permission of permissions) {
      if (this.isGranted(permission)) {
        return true;
      }
    }

    return false;
  }

  s(key: string): string {
    return eaf.setting.get(key);
  }

  appRootUrl(): string {
    return this.appUrlService.appRootUrl;
  }

  get currentTheme(): UiCustomizationSettingsDto {
    return this.appSession.theme;
  }
}
